import { INavData } from "../../projects/coreui/angular/src/lib/sidebar/public_api";

export const navItems: INavData[] = [
  {
    name: "Dashboard",
    url: "/dashboard",
    icon: "icon-speedometer",
    badge: {
      variant: "info",
      text: "NEW",
    },
  },
  {
    title: true,
    name: "Title",
  },
  {
    name: "Disabled",
    url: "/dashboard",
    icon: "icon-ban",
    attributes: { disabled: true },
  },
  {
    name: "Download CoreUI",
    url: "http://coreui.io/angular/",
    icon: "icon-cloud-download",
    class: "mt-auto",
    variant: "success",
    attributes: { target: "_blank", rel: "noopener" },
  },
  {
    name: "Try CoreUI PRO",
    url: "http://coreui.io/pro/angular/",
    icon: "icon-layers",
    variant: "danger",
    attributes: { target: "_blank", rel: "noopener" },
  },
];
